import Vue from 'vue'
import VueRouter from 'vue-router'
import Donate from "../views/Donate.vue"
import DonateFormulaire from "../views/DonateFormulaire.vue"
import DonateIFrame from "../views/DonateIFrame.vue"
import DonateFormulaireIFrame from "../views/DonateFormulaireIFrame.vue"
import FormulaireAdhesionView from "../views/FormulaireAdhesion.vue"
import FormulaireAdhesion from "../components/adhesion/form.vue"
import DejaMembre from "../components/adhesion/DejaMembre.vue"
import Merci from '../components/donate/merci.vue'
import MerciAdhesion from '../components/adhesion/merciAdhesion.vue'
import ErreurPaiement from '../components/donate/erreurPaiement.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:campagneId/faire-un-don',
    component: Donate,
    children: [
      { path: '', name: "FaireUnDon", component: DonateFormulaire, meta: { title: 'Faire un don - Amnistie Internationale' } },
      { path: 'merci/:sasDeDonId', name: "Merci", props: true, component: Merci, meta: { title: 'Merci pour votre don - Amnistie Internationale' } },
      { path: 'erreur', name: "Erreur", component: ErreurPaiement, meta: { title: 'Une erreur est survenue lors du paiement - Amnistie Internationale' } }
    ]
  },
  {
    path: '/iframe/:campagneId/faire-un-don',
    component: DonateIFrame,
    children: [
      { path: '', name: "FaireUnDonIFrame", component: DonateFormulaireIFrame, meta: { title: 'Faire un don - Amnistie Internationale' } },
      { path: 'merci/:sasDeDonId', name: "MerciIFrame", props: true, component: Merci, meta: { title: 'Merci pour votre don - Amnistie Internationale' } },
      { path: 'erreur', name: "ErreurIFrame", component: ErreurPaiement, meta: { title: 'Une erreur est survenue lors du paiement - Amnistie Internationale' } }
    ]
  },
  {
    path: '/formulaire-adhesion',
    component: FormulaireAdhesionView,
    children: [
      { path: '', name: "FormulaireAdhesion", component: FormulaireAdhesion, meta: { title: 'Formulaire d\'adhésion - Amnistie Internationale' } },
      { path: 'deja-membre', name: "DejaMembre", component: DejaMembre, meta: { title: 'Formulaire d\'adhésion - Vous êtes déjà membre!' } },
      { path: 'merci/:sasAdhesionId', name: "MerciAdhesion", props: true, component: MerciAdhesion, meta: { title: 'Merci pour votre adhésion - Amnistie Internationale' } },
      { path: 'erreur', name: "ErreurAdhesion", component: ErreurPaiement, meta: { title: 'Une erreur est survenue lors de votre adhésion - Amnistie Internationale' } }
    ]
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = 'Amnistie Internationale'
  }
  next()
})

export default router
